"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var bleedContainerStyles = styles_1.makeStyles(function (theme) {
    var _a;
    return ({
        root: (_a = {},
            _a[theme.breakpoints.down('sm')] = {
                paddingLeft: 0,
                paddingRight: 0,
            },
            _a),
    });
}, { name: 'GqlCheckout_BleedContainer' });
exports.default = bleedContainerStyles;
